import baseApi from './baseApi'

export const childApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getChild: builder.query({
      query: ({ userToken }) => ({
        method: 'POST',
        url: '/child',
        body: { person_uid: userToken },
      }),
      transformResponse: (data) => {
        return data.Status.children.registred_child.map((child) => ({
          ...child,
          id: child.user_uid,
          value: child.user_uid,
          label: child.username,
        }))
      },
      providesTags: ['Children'],
    }),

    addChild: builder.mutation({
      query: (data) => ({
        method: 'POST',
        url: '/add_child',
        body: data,
      }),
      invalidatesTags: ['Children'],
    }),

    updateChild: builder.mutation({
      query: (data) => ({
        method: 'POST',
        url: '/edit_child',
        body: data,
      }),
      transformErrorResponse: (base, meta, arg) => {
        return { message: meta.response.statusText }
      },

      invalidatesTags: ['Children'],
    }),

    deleteChild: builder.mutation({
      query: (data) => ({
        method: 'POST',
        url: '/delete_child',
        body: data,
      }),
      transformErrorResponse: (base, meta, arg) => {
        return { message: meta.response.statusText }
      },

      invalidatesTags: ['Children'],
    }),
  }),
  overrideExisting: false,
})

// auto-generated based on the defined endpoints
export const { useGetChildQuery, useAddChildMutation, useUpdateChildMutation, useDeleteChildMutation } = childApi
